<template>
  <div class="contactsImport" v-if="show">
    <el-dialog
      :visible="visible"
      @close="close"
      :close-on-click-modal="false"
      title="导入联系人"
    >
      <div class="content">
        <div class="default" v-if="status == 0">
          <p>
            1.
            下载并按模版要求填写联系人信息，一次最多支持导入5000条数据，下载模版：
          </p>
          <b
            >《<a
              href="https://res.haizol.com/base/file/supplier-customer/%E8%81%94%E7%B3%BB%E4%BA%BA%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx"
              download
              >联系人导入模版</a
            >》</b
          >
          <p>2. 上传已填写好的联系人模版文件，选择导入文件</p>

          <div class="upload">
            <el-upload ref="" action="" :accept="accept" :before-upload="beforeUpload">
              <div class="upload-box">
                <div class="text" @click.stop>{{ file ? file.name : '' }}</div>
                <el-button slot="trigger" size="small" type="primary" plain
                  >选择文件
                </el-button>
              </div>
            </el-upload>
          </div>
        </div>

        <div class="loading" v-else-if="status == 1">
          <i class="el-icon-loading"></i>
          <p>数据导入中</p>
          <div>
            当前数据正在导入，可以点击【最小化】隐藏当前页面，数据导入不受影响
          </div>
        </div>

        <div class="accomplish" v-else-if="status == 2">
          <i class="iconfont icon-icon-wancheng"></i>
          <p>数据导入完成</p>
        </div>

        <div class="btns">
          <!-- 待导入 -->
          <el-button v-if="status == 0" @click="close" :disabled="btnLoading"
            >取消</el-button
          >
          <el-button
            v-if="status == 0"
            type="primary"
            @click="startImport"
            :loading="btnLoading"
            :disabled="!file"
            >开始导入</el-button
          >
          <!-- 导入中 -->
          <el-button type="primary" v-if="status == 1" @click="close"
            >最小化</el-button
          >
          <!-- 导入完成 -->
          <el-button type="primary" v-if="status == 2" @click="accomplish"
            >关闭</el-button
          >
        </div>
      </div>
    </el-dialog>
    <div class="status-fixed" v-if="!visible">
      <div class="loading" @click="SET_VISIBLE(true)" v-if="status == 1">
        <i class="iconfont icon-icon-jiazaizhong"></i>
        <span>导入中</span>
      </div>
      <div class="accomplish" @click="SET_VISIBLE(true)" v-if="status == 2">
        <i class="iconfont icon-icon-wancheng"></i>
        <span>导入完成</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import {
  importContact,
  getImportContactTask,
  clearImportContact,
} from '@/utils/api/customer'
export default {
  computed: {
    ...mapState('contactsImport', ['show', 'status']),
    visible: {
      get() {
        return this.$store.state.contactsImport.visible
      },
      set(val) {
        this.SET_VISIBLE(val)
      },
    },
  },
  data() {
    return {
      file: null,
      pollingTime: null,
      btnLoading: false,
      accept: '.xlsx, .xls',
      isDestroy: false, // 组件是否销毁
    }
  },
  methods: {
    ...mapMutations('contactsImport', [
      'SET_SHOW',
      'SET_STATUS',
      'SET_VISIBLE',
    ]),

    close() {
      if (this.status === 2) return this.accomplish()
      if (this.btnLoading) return this.$message.error('正在导入中，不支持取消')
      // 如果状态为导入中，最小化
      if (this.status == 1) return this.SET_VISIBLE(false)
      this.SET_SHOW(false)
      this.SET_VISIBLE(false)
      this.file = null
    },

    // 开始导入
    async startImport() {
      try {
        if (!this.file) return this.$message.error('请上传附件')
        this.btnLoading = true
        const formData = new FormData()
        formData.append('file', this.file)
        const res = await importContact(formData)
        if (res.rspResult.bizCode === 200) {
          this.file = null
          this.SET_STATUS(1)
          this.getImportStatus()
        }
        this.btnLoading = false
      } catch (err) {
        console.error(
          '❌ ~ file: ContactsImport.vue:137 ~ startImport ~ err:',
          err
        )
        this.btnLoading = false
      }
    },

    beforeUpload(file) {
      try {
        // 判断附件类型是否符合
        let name = file.name ? file.name : ''
        let ext = name
          ? name.substr(name.lastIndexOf('.') + 1, name.length)
          : true
        ext = ext.toLowerCase()
        let isExt = this.accept.indexOf(ext) < 0
        if (isExt) {
          this.$message.error('请上传正确的格式')
          return false
        }

        // 判断文件是否超出5M
        const size = file.size / 1024 / 1024
        if (size > 5) {
          this.$message.error('上传文件不能超过5M，请重新选择')
          return false
        }
        this.file = file
        return false
      } catch (err) {
        console.error(
          '❌ ~ file: ContactsImport.vue:181 ~ beforeUpload ~ err:',
          err
        )
      }
    },

    // 获取导入状态
    async getImportStatus() {
      try {
        const res = await getImportContactTask()
        if (res.rspResult.bizCode === 200) {
          if (res.data.isExistImportTask === 1) {
            // 正在导入
            this.SET_STATUS(1)
            this.pollingTime = setTimeout(() => {
              if(this.isDestroy) return // 如果当前组件已销毁，暂停轮询
              this.getImportStatus()
            }, 5000)
          } else if (res.data.isExistImportTask === 2) {
            // 导入完成
            this.SET_STATUS(2)
            this.$emit('getList')
          } else {
            // 不存在导入任务
            this.SET_STATUS(0)
          }
        }
      } catch (err) {
        console.error(
          '❌ ~ file: ContactsImport.vue:168 ~ getImportStatus ~ err:',
          err
        )
      }
    },

    stopPolling() {
      clearTimeout(this.pollingTime)
      this.pollingTime = null
    },

    // 已完成状态下点击 关闭
    async accomplish() {
      try {
        const res = await clearImportContact({})
        if (res.rspResult.bizCode === 200) {
          this.SET_STATUS(0)
          this.SET_SHOW(false)
          this.SET_VISIBLE(false)
          this.file = null
        }
      } catch (err) {
        console.error(
          '❌ ~ file: ContactsImport.vue:188 ~ accomplish ~ err:',
          err
        )
      }
    },
  },
  async created() {
    this.isDestroy = false
    try {
      const res = await getImportContactTask()
      if (res.rspResult.bizCode === 200) {
        if (res.data.isExistImportTask === 1) {
          // 正在导入
          this.SET_STATUS(1)
          this.SET_VISIBLE(false)
          this.SET_SHOW(true)
          this.pollingTime = setTimeout(() => {
            this.getImportStatus()
          }, 5000)
        } else if (res.data.isExistImportTask === 2) {
          // 导入完成
          this.SET_STATUS(2)
          this.SET_SHOW(true)
          this.SET_VISIBLE(false)
        } else {
          // 不存在导入任务
          this.SET_STATUS(0)
          this.SET_SHOW(false)
          this.SET_VISIBLE(false)
        }
      }
    } catch (err) {
      console.error('❌ ~ file: ContactsImport.vue:217 ~ created ~ err:', err)
    }
  },

  beforeDestroy() {
    this.isDestroy = true
    this.stopPolling()
  },
}
</script>

<style lang="scss" scoped>
.contactsImport {
  .status-fixed {
    position: fixed;
    bottom: 120px;
    right: 39px;
    > div {
      height: 36px;
      background: #ffffff;
      border: 1px solid #cfd5df;
      box-shadow: 0 2px 4px 0 #0014331a;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      span {
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #4f5d78;
      }
    }
    .loading {
      width: 100px;
      i {
        margin-right: 8px;
        transition: color 0.15s linear;
        animation: rotating 2s linear infinite;
        color: #318ced;
      }
    }
    .accomplish {
      width: 112px;
      i {
        margin-right: 8px;
        color: #318ced;
      }
    }
  }
  ::v-deep .el-dialog {
    width: 640px;
    .el-dialog__header {
      padding: 32px 32px 28px 32px;
      span {
        height: 16px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        font-size: 16px;
        color: #16181a;
      }
      .el-dialog__headerbtn {
        top: 32px;
        right: 32px;
      }
    }
    .el-dialog__body {
      padding: 0 32px 32px 32px;
      .content {
        .default {
          p {
            margin-top: 24px;
            &:first-child {
              margin-top: 0;
            }
          }
          b {
            font-weight: normal;
            a {
              color: #066eb7;
            }
          }
          .upload {
            margin-top: 14px;
            &-box {
              display: flex;
              .text {
                width: 288px;
                height: 36px;
                background: #f5f7fa;
                border-radius: 4px;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                line-height: 36px;
                padding: 0 20px;
                text-align: left;
                box-sizing: border-box;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .el-button {
                border: none;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                button {
                }
              }
            }
          }
        }
        /* @keyframes rotating {
            0% {
                transform: rotateZ(0deg);
            }
            100% {
                transform: rotateZ(360deg);
            }
          } */
        .loading,
        .accomplish {
          text-align: center;
          i {
            font-size: 42px;
            color: #318ced;
            transition: color 0.15s linear;
            animation: rotating 2s linear infinite;
          }
          p {
            margin: 11px 0 61px 0;
            height: 14px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #16181a;
            letter-spacing: 0;
          }
          div {
            height: 14px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #4f5d78;
            letter-spacing: 0;
            margin-bottom: 39px;
          }
        }
        .accomplish {
          text-align: center;
          p {
            margin-bottom: 58px;
            margin-top: 25px;
          }
          .black {
            color: rgb(25, 27, 27);
          }
          .yellow {
            color: rgb(229, 130, 58);
          }
          .red {
            color: rgb(217, 51, 49);
          }
          strong {
            margin: 12px 0 52px 0;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #066eb7;
            cursor: pointer;
          }
        }
        .btns {
          text-align: right;
          margin-top: 32px;
        }
      }
    }
  }
}
</style>
